import { ValidationType } from '../configs'
import { TValidationType } from '../models'

export const isValidationTypeOnBlur = (validationType: TValidationType) =>
  (Array.isArray(validationType) && validationType.includes(ValidationType.ONBLUR)) ||
  validationType === ValidationType.ONBLUR

export const isValidationTypeOnChange = (validationType: TValidationType) =>
  (Array.isArray(validationType) && validationType.includes(ValidationType.ONCHANGE)) ||
  validationType === ValidationType.ONCHANGE
